let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("W2aDd")).then(() => parcelRequire('6LiLg'));